// common
export const RESET_STATE = 'reset'

// --

// licencereport entries
export const ADD_LICENCEREPORT_ENTRY = 'addEntry'
export const REMOVE_LICENCEREPORT_ENTRY = 'removeEntry'
export const SET_LICENCEREPORT_ENTRY = 'setEntry'

export const ADD_LICENCEREPORT_EXCHANGE_RATE = 'addRate'
export const REMOVE_LICENCEREPORT_EXCHANGE_RATE = 'removeRate'
export const SET_LICENCEREPORT_EXCHANGE_RATE = 'setRate'

export const ADD_LICENCEREPORT_STATUS = 'addStatus'
export const REMOVE_LICENCEREPORT_STATUS = 'removeStatus'
export const SET_LICENCEREPORT_STATUS = 'setStatus'

// licencereport
export const SET_LICENCEREPORT_DIRTY = 'setDirty'
export const SET_LICENCEREPORT = 'set'
